import {
	getStudyCourseUpcomingDetails,
	getStudyWebinarUpcomingDetails,
	getStudyCourseDetails,
	getStudyWebinarDetails,
} from "../../api/api";
import { WorkshopContentAuth } from "../../pages/Workshop/WorkshopContentAuth";
import { createFileRoute, redirect } from "@tanstack/react-router";
import type { StudyStatus } from "./_app.study.$studyId";
import type { StudyWorkshopDetails } from "@/api/studyWorkshopDetails.types";
import { getAccessToken } from "@/utils/storage/authStorage";

export const Route = createFileRoute(
	"/(app)/_app/workshops_/$type/$slugId/auth"
)({
	component: WorkshopContentAuth,
	beforeLoad: async ({ context }) => {
		// Get token from context or Storage
		const token =
			(context as { token: string | null }).token || (await getAccessToken());

		if (!token) {
			redirect({
				to: "/login"
			});
		}

		return { token };
	},
	validateSearch: (
		search: Record<string, unknown>
	): { status: StudyStatus } => {
		return {
			status: (search["status"] as StudyStatus) || "unknown",
		};
	},
	loaderDeps: ({ search }) => {
		return {
			status: search.status.toLowerCase() as
				| "kurs-online"
				| "webinar-online"
				| "szkolenie"
				| "webinar"
				| "unknown",
		};
	},
	loader: async (loaderProps) => {
		const { params, deps } = loaderProps;
		let studyWorkshopDetails: StudyWorkshopDetails | undefined;
		const isCourse =
			deps.status.includes("szkolenie") || deps.status.includes("kurs");
		const isWebinar = deps.status.includes("webinar");
		const isUpcoming = deps.status.includes("online");
		if (isCourse && isUpcoming) {
			studyWorkshopDetails = await getStudyCourseUpcomingDetails(params.slugId);
		} else if (isWebinar && isUpcoming) {
			studyWorkshopDetails = await getStudyWebinarUpcomingDetails(
				params.slugId
			);
		} else if (isCourse) {
			studyWorkshopDetails = await getStudyCourseDetails(params.slugId);
		} else if (isWebinar) {
			studyWorkshopDetails = await getStudyWebinarDetails(params.slugId);
		}
		if (studyWorkshopDetails?.isAssigned) {
			redirect({
				to: "/study/$studyId",
				params: { studyId: studyWorkshopDetails.course.slug },
				search: {
					status: studyWorkshopDetails.course.type_field as StudyStatus,
				},
				throw: true,
			});
		}
		return {
			studyWorkshopDetails,
		};
	},
});
